'use client';

import { ReactNode } from 'react';
import Button from '@/components/button';
import { ListFilterItemDTO, ListLocationFilterDTO } from '@/features/filters/types/filters.dto';

interface ProductFilterBtnGroupProps {
  items: (ListFilterItemDTO | ListLocationFilterDTO)[];
  selectedItems: string[];
  callback: (code: string) => void;
  className?: string;
  startListChildren?: ReactNode;
  chipsHiddenOnDesktop?: boolean;
  showCityChips: boolean;
}

const btnStyles = 'border-(--mui-palette-quinary-light) text-(--mui-palette-primary-main)';

const btnSelectedStyles =
  'border-(--mui-palette-primary-main) bg-(--mui-palette-primary-_states-hover)';

const btnHoverStyles =
  'hover:border-(--mui-palette-primary-_states-outlinedBorder) hover:bg-(--mui-palette-primary-_states-hover)';

export const ProductFilterBtnGroup = ({
  items,
  selectedItems,
  callback,
  className,
  startListChildren,
  chipsHiddenOnDesktop,
  showCityChips
}: ProductFilterBtnGroupProps) => {
  const handleFilterClick = (code: string) => {
    if (callback) {
      callback(code);
    }
  };

  if (!items || !items.length) {
    return null;
  }

  return (
    <div
      className={`flex flex-row items-center gap-x-3 min-h-max md:pb-0 overflow-y-hidden overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden ${className || ''}`}
    >
      {!!startListChildren && startListChildren}
      {showCityChips &&
        items.map((item) => (
          <Button
            key={item.code}
            variant="outlined"
            size="small"
            className={`capitalize min-w-max  bg-transparent ${btnHoverStyles} ${selectedItems.includes(item.code) ? btnSelectedStyles : btnStyles} ${chipsHiddenOnDesktop && 'md:hidden'}`}
            onClick={() => handleFilterClick(item.code)}
          >
            {item.name}
          </Button>
        ))}
    </div>
  );
};
